<!--走进资环/成果案件-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--PC端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="walkinto" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="30vw" class='carousel_class'>
          <el-carousel-item v-for='item in projectList' :key='item.id'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--成果案件标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--成果案件-->
      <el-row :gutter="20" class="box-width introduce">
        <el-col :lg="8" :md="12"  :sm="12" :xs="24" v-for="item in projectOne" :key="item.id" class="image-container">
          <a href="#" @click='handleProjectDetail(item.id)'>
            <el-card :body-style="{ padding: '0px' }" class="card_box">
              <el-image
                alt="Image Description"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
                :fit="fit"></el-image>
              <div class="text">
                <h4 class="documenTitle">{{ item.title }}</h4>
              </div>
              <!--鼠标移入显示-->
              <div class="text-box">
                <div v-html="item.briefIntroduction" style="min-height: 174px"></div>
                <p style="text-align: center;bottom: 10px">点击查看详情</p>
              </div>
            </el-card>
          </a>
        </el-col>
      </el-row>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in projectList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--成果案件-->
        <div class="boxs_content" v-for="item in projectOne" :key="item.id">
          <a href="#" @click='handleProjectDetail(item.id)'>
            <div>
              <el-image
                style="width: 100%;margin-bottom: 8px"
                alt="Image Description"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
                :fit="fit"></el-image>
              <div class="index_title">
                <h1>{{ item.title}}</h1>
              </div>
              <div v-html="item.briefIntroduction" class="htmlImgSize"></div>
            </div>
          </a>
        </div>

      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

  </div>
</template>

<script>
import { findBanner, findEnName, findProjectOne } from '@api/zh'
import header from '../components/header.vue'
import footer from '../components/footer.vue'

export default {
  data () {
    return {
      components: {
        tail: header,
        tail1: footer
      },
      player: null,
      tabId: null,
      enNameOne: '',
      cnNameOne: '',
      activeName: 'first',
      fit: 'cover',
      navUrl: require('@assets/images/index/lunBo.png'),
      src: require('@assets/images/index/kjtb.png'),
      // 产品展示
      url: require('@assets/images/index/chanping1.png'),
      url1: require('@assets/images/index/chanping.png'),
      url2: require('@assets/images/index/chanping2.png'),
      // 采集产品
      gatherUrl: require('@assets/images/index/caiji.png'),
      projectList: [],
      projectOne: []
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.projectList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectProjectOne(data[0].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    async selectProjectOne (enNameId) {
      let that = this
      await findProjectOne(enNameId).then(res => {
        that.projectOne = res.data
      })
    },
    handleClick (item) {},
    /** 详情 */
    handleProjectDetail: function (id) {
      this.$router.push({
        path: '/caseDetails',
        query: {
          projectId: id
        }
      })
    }
  }
}
</script>
